<section class="with-mat-form-field sip-address">
  <div class="mat-body-1 property-header">{{ "ONSIP_I18N.SIP_ADDRESS" | translate }}</div>
  <div>{{ recManager.username }}&#64;{{ domain$ | async }}</div>
</section>
<section class="with-mat-form-field sip-address">
  <div class="mat-body-1 property-header">{{ "ONSIP_I18N.PIN" | translate }}</div>
  <div>{{ recManager.pin }}</div>
</section>
<section class="with-mat-form-field extensions">
  <div class="mat-body-1">{{ "ONSIP_I18N.EXTENSIONS" | translate }}</div>
  @if ((extensions$ | async)?.length) { @for (extension of extensions$ | async; track extension) {
  <div class="mat-body-2">
    {{ extension | formatExtensions }}
  </div>
  } }@else {
  <div class="value mat-body-2">{{ "ONSIP_I18N.NO_EXTENSIONS_ADDED" | translate }}</div>
  }
</section>
<div class="page-view-controls">
  <button mat-flat-button class="toggle-button" color="primary" (click)="togglePanel()">
    {{ "ONSIP_I18N.EDIT" | translate }}
  </button>
</div>
